import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../../action/notifications/notifications';

import * as Api from '../../../api/api';

import { LanguageCode } from '../../../util/languages';

export const sendSurveyReminder = (
  surveyId: number,
  message: Record<LanguageCode, string>,
  subject: Record<LanguageCode, string>,
) =>
  createGenericDispatcher<Array<ScheduledMessage>>({
    name: 'SEND_SURVEY_REMINDER',
    loadFunction: () =>
      Api.post(`/surveys/${surveyId}/reminders`, {
        body: JSON.stringify({
          message: message.en,
          subject: subject.en,
          spanishMessageBody: message.es,
          spanishSubject: subject.es,
        }),
      }),
    args: { surveyId, message },
    onSuccess: (dispatch, _getState, data) => {
      dispatch(
        addNotificationAction({
          key: `survey-reminder-${surveyId}`,
          message: `Sending ${data.length} reminder${data.length === 1 ? '' : 's'}...`,
        }),
      );
    },
  });
